import { Card, Typography, Tooltip, IconButton } from '@material-tailwind/react'
import { TbDoor } from 'react-icons/tb'
import { FiX } from 'react-icons/fi'
import { norm } from './utils'

export function ActiveCard({ inv, fmt, onOpenUsage, onRequestCancel }) {
  const vd = inv?.visitor_data || {}
  const alias = vd.token_name && norm(vd.token_name) !== norm(vd.name)
  const company = vd.origin_company || vd.company_name || null
  const invitedBy = inv?.created_by_name || null
  const acceptedBy = inv?.approved_by_name || null
  const sameUser   = invitedBy && acceptedBy && norm(invitedBy) === norm(acceptedBy)

  return (
    <Card className="w-full p-4 border border-gray-200 relative">
      {!!inv?.usage_data?.events?.length && (
        <div className="absolute bottom-2 right-2">
          <Tooltip content="Ver registro de usos">
            <IconButton
              variant="text"
              className="bg-white/80 hover:bg-white rounded-full shadow-sm"
              onClick={() => onOpenUsage(inv)}
              aria-label="Ver registro de usos"
              title="Ver registro de usos"
            >
              <TbDoor className="h-5 w-5" />
            </IconButton>
          </Tooltip>
        </div>
      )}

      <Tooltip content="Cancelar esta visita">
        <IconButton
          size="sm"
          color="red"
          variant="text"
          className="absolute top-2 right-2"
          onClick={() => onRequestCancel(inv)}
          aria-label="Cancelar visita"
          title="Cancelar visita"
        >
          <FiX />
        </IconButton>
      </Tooltip>

      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2">
        <div className="min-w-0 pr-8">
          <Typography className="font-semibold truncate">{vd.name || '—'}</Typography>
          {alias && <p className="text-xs italic text-gray-500 truncate">{vd.token_name}</p>}
          {company && <p className="text-xs text-gray-700 truncate">{company}</p>}
          <p className="text-sm text-gray-600 truncate">{vd.email || '—'}</p>
          {vd.document_number && (
            <p className="text-xs text-gray-500 truncate">Doc: {vd.document_number}</p>
          )}
        </div>
        <div className="text-sm text-gray-700">
          <p className="font-medium truncate">{inv.office_name}</p>
          <p className="text-xs">Ventana: {fmt(inv.starts_at)} – {fmt(inv.ends_at)}</p>
          {vd.host_person && <p className="text-xs text-gray-500">Visita a: {vd.host_person}</p>}
          {sameUser && (
            <p className="text-[11px] text-gray-500 mt-0.5 truncate">
              Invitado y aceptado por: {invitedBy}
            </p>
          )}
          {!sameUser && invitedBy && (
            <p className="text-[11px] text-gray-500 mt-0.5 truncate">Invitado por: {invitedBy}</p>
          )}
          {!sameUser && acceptedBy && (
            <p className="text-[11px] text-gray-500 mt-0.5 truncate">Aceptado por: {acceptedBy}</p>
          )}
        </div>
      </div>
    </Card>
  )
}